/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Card, CardBody, Flex, Heading } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { CashCenterDetails } from "../../components/cashCenter/cash-center-details";
import { useCashCenterDetails } from "../../services/cash-center";
import { HasPermission } from "../../utils/helper";
import { useUser } from "../../hooks/use-user";

export default function CashCenterDetailsView() {
  const [cashCenter, setCashCenter] = useState({});
  const user = useUser();
  const params = useParams();
  const {
    mutate: getCashCenterDetails,
    data: cashCenterDetailsRes,
    isPending: gettingCashCenterDetails,
    error: cashCenterDetailsError,
  } = useCashCenterDetails();

  useEffect(() => {
    if (cashCenterDetailsRes) {
      setCashCenter(cashCenterDetailsRes.data);
    }
  }, [cashCenterDetailsRes, cashCenterDetailsError]);
  useEffect(() => {
    if (params.cashCenterId) {
      getCashCenterDetails(params.cashCenterId);
    }
  }, []);
  const canEdit = useMemo(() => {
    return HasPermission(user, "CashCenter", "Edit");
  }, [user]);
  return (
    <>
      {gettingCashCenterDetails ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Cash Centers", link: Paths.cashCenter },
            { text: "Cash Center Details", isCurrentPage: true },
          ]}
        />

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Flex w="100%" justify="space-between" flexDirection="row">
                <Heading>{cashCenter.name}</Heading>
                {canEdit ? (
                  <Button
                    as={Link}
                    to={`${Paths.editCashCenter}/${cashCenter.id}`}
                  >
                    Edit
                  </Button>
                ) : (
                  <></>
                )}
              </Flex>
              <div className="add-location-form">
                {cashCenter.name ? (
                  <CashCenterDetails cashCenter={cashCenter} />
                ) : (
                  <></>
                )}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
